"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const useDataProvider_1 = require("../../hooks/useDataProvider");
const TGOptionSelectorModal_1 = __importDefault(require("../Common/Modals/TGOptionSelectorModal"));
const clsx_1 = __importDefault(require("clsx"));
const hooks_1 = require("../../hooks");
const Common_1 = require("../../components/FormFields/Common");
const TGPageSelectField = props => {
    const classes = (0, Common_1.useStyles)();
    const { options, value: unknownValue, dataProvider, onChange, multiSelect, readOnly, warning, computed, oneLine, translateFunction = text => text } = props;
    const { searchText, handleSearchText } = (0, hooks_1.useSearch)();
    const [selectedOptions, setSelectedOptions] = (0, react_1.useState)([]);
    const value = (0, react_1.useMemo)(() => {
        if (Array.isArray(unknownValue)) {
            return unknownValue.map(x => {
                if (typeof x === 'number' || typeof x === 'string')
                    return x;
                return String(x);
            });
        }
        else if (typeof unknownValue === 'number' || typeof unknownValue === 'string')
            return unknownValue;
        return String(unknownValue);
    }, [unknownValue]);
    const [optionSelectorOpen, setOptionSelectorOpen] = (0, react_1.useState)(false);
    const { options: dataProviderOptions, computeOptions, valueOptions, clearPageInfo, pageInfo, loading, } = (0, useDataProvider_1.useDataProvider)({
        dataProvider,
        options,
        value,
        searchText,
        selectedOptions,
    });
    (0, react_1.useEffect)(() => {
        clearPageInfo();
        computeOptions(undefined, true); //Load options right away so initial values will show up correctly
    }, []);
    (0, react_1.useEffect)(() => {
        if (optionSelectorOpen) {
            clearPageInfo();
            computeOptions(undefined, true);
        }
    }, [searchText]);
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    const openOptionSelectorModal = () => {
        if (readOnly) {
            return;
        }
        setOptionSelectorOpen(true);
    };
    const closeOptionSelectorModal = () => {
        setOptionSelectorOpen(false);
    };
    const label = (react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, calculated: computed, oneLine: oneLine, translateFunction: translateFunction }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: {
                wordWrap: 'break-word',
                fontFamily: 'Roboto,Roboto-Light',
            } },
            react_1.default.createElement("p", { style: Object.assign({ margin: 0, fontWeight: 300, fontSize: 14, lineHeight: '130%' }, (props.truncate
                    ? {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                    : undefined)) }, label),
            react_1.default.createElement(core_1.Input, { className: (0, clsx_1.default)(warning && classes.warningBorderBottom), onClick: openOptionSelectorModal, value: (valueOptions === null || valueOptions === void 0 ? void 0 : valueOptions.map(valueOption => valueOption.label).join(', ')) || '', readOnly: true, disabled: readOnly, endAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                    react_1.default.createElement(core_1.Icon, { "aria-label": "toggle password visibility" },
                        react_1.default.createElement(icons_1.ArrowRight, null))) }),
            react_1.default.createElement(TGOptionSelectorModal_1.default, { open: optionSelectorOpen, filterPlaceHolder: "Search", pathToLabel: "label", pathToValue: "value", multiSelect: multiSelect, onDone: (value) => {
                    onChange(value);
                    closeOptionSelectorModal();
                }, onCancel: closeOptionSelectorModal, options: dataProviderOptions || [], value: value, setOpen: setOptionSelectorOpen, fetchMoreData: computeOptions, hasNextPage: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) || false, clearPageInfo: clearPageInfo, searchText: searchText, handleSearchText: handleSearchText, setSelectedOptions: setSelectedOptions, loading: loading }))));
};
exports.default = TGPageSelectField;
//# sourceMappingURL=TGPageSelectField.js.map